import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { showErrorToast } from '../../state/toasts'
import * as rest from '../../services'
import * as components from '../../components'
import { ICONS, renderers, validations } from '../../components'
import { TicketUpdateTabs } from './TicketUpdateTabs'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import { navigate } from '@reach/router'
export const TicketSearchForm = ({ handleSubmit, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={5}>
          <Field
            name="search"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={1}>
          <ReactBootstrap.Button
            className={'mt-3'}
            variant="outline-success"
            type="submit"
            disabled={submitting}
          >
            {ICONS.SEARCH}
          </ReactBootstrap.Button>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}

export const TicketSearchFormDisplay = reduxForm({
  form: 'ticket-search-form',
})(TicketSearchForm)

export const TicketUpdatePageSearch = ({ header }) => {
  return (
    <ReactBootstrap.Row>
      <ReactBootstrap.Col style={{ paddingTop: '30px' }} xs={6}>
        {header || 'Update'}
      </ReactBootstrap.Col>
      <ReactBootstrap.Col style={{ paddingTop: '5px' }} xs={6}>
        <TicketSearchFormDisplay
          onSubmit={(values) => {
            navigate(`/dashboard/ticket/${values.search}`)
          }}
        />
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}

export const TicketUpdatePage = ({
  purchaseOrderNumber,
  activeKey,
}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [activeTabKey, setActiveTabKey] = useState(activeKey || 'jobsheet')
  const [ticket, setTicket] = useState(null)

  const loadTicket = (newTicket) => {
    if(!ticket){
      setLoading(true)
      const promise = new rest.TicketService().details_by_reference_number(
              purchaseOrderNumber
            )
      promise
        .then((response) => {
          setTicket(response.results ? response.results[0] : response)
          setLoading(false)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast('Could not read ticket details', errors.response)
          )
        })
    }
    setTicket({...newTicket})
  }

  useEffect(() => {
    if (purchaseOrderNumber) {
      loadTicket()
    }
  }, [purchaseOrderNumber])

  return (
    <>

          {loading || !ticket ? (
            <components.Loading />
          ) : (
            <TicketUpdateTabs
              ticket={ticket}
              activeKey={activeTabKey}
              onSelect={(k) => setActiveTabKey(k)}
              onTicketUpdate={loadTicket}
            />
          )}

    </>
  )
}
